import React from 'react'

import LoanPipelineTable from './LoanPipelineTable'
import LoanPipelineTableDeprecated from './LoanPipelineTableDeprecated'
import PipelineLoadingSiteConfigCard from './PipelineLoadingSiteConfigCard'

type PipelineTableProps = Readonly<{
	pageTitle: string
	siteConfigLoading: boolean
	localPipeline: boolean
}>

function PipelineTable({
	pageTitle,
	localPipeline,
	siteConfigLoading,
}: PipelineTableProps) {
	if (siteConfigLoading) return <PipelineLoadingSiteConfigCard />

	// ToDo: This logic will be removed in the future check task #9819184358
	// Task Name: [WEB] - Delete LoanPipelineTableDeprecated component after useLocalPipeline prop in LOS Settings is no longer needed
	// Task Link: https://mortgage-automation-technologies.monday.com/boards/5842126081/pulses/9819184358
	return localPipeline ? (
		<LoanPipelineTable pageTitle={pageTitle} />
	) : (
		<LoanPipelineTableDeprecated pageTitle={pageTitle} />
	)
}

export default PipelineTable
